<template>
  <div class="modal-content">
    <div class="modal-body">
      <reservation-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import ReservationDetails from '~/components/ReservationDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (reservation) {
      this.$emit('save', reservation)
    }
  },
  components: {
    ReservationDetails
  }
}

</script>